<template>
  <div class="fund-sharing-wrap">
    <div class="fund-sharing-chart" ref="sharing"></div>
    <a-checkbox-group
      class="legend-checkbox"
      :options="plainOptions"
      v-model="checkedList"
      @change="onChange(e, index)"
    />
    <div class="tip" v-if="isMainMoney">
      提示：该走势图为陆股通成分股大单资金流向，非北向资金，仅供参考。
    </div>
  </div>
</template>

<script>
import event from '../event';
import { getTimeList } from '../../common/utils/handleCaptialFlowChartData.js';

export default {
  props: {
    plainOptions: Array,
    name: String,
    indexData: Object,
    shareData: Object,
    newShareData: Object,
    sharingTab: Number, // tab 索引
    isMainMoney: Boolean, // 是否是主力净流入
  },
  data() {
    return {
      checkedList: this.plainOptions,
      surIndex: {}, // 叠加指数
      indexName: '',
      currentY: {}, // 当前指数
      statCont: [this.plainOptions[0]], // 储存 onchange 之前的选中数据， 埋点中用其判断 cancel 或 select
      northAxis: [],
      northAxis_buy: [],
      northAxis_mm: [], //陆股通主力净流入x轴
      southAxis: [],
      southAxis_buy: [],
      colorConfig: '#19191b',
      djColor: '#fff',
      lineColor: '#1f2125',
    };
  },
  created() {
    this.createNorthAxis_mm();
    this.northAxis = getTimeList(
      { start: '09:10', end: '15:00' },
      { start: '09:10', end: '15:00' }
    );
    this.northAxis_buy = getTimeList(
      { start: '09:25', end: '15:00' },
      { start: '09:25', end: '15:00' }
    );
    this.southAxis = getTimeList(
      { start: '09:00', end: '16:10' },
      { start: '09:00', end: '16:10' },
      { start: '1200', end: '1300' }
    );
    this.southAxis_buy = getTimeList(
      { start: '09:20', end: '16:10' },
      { start: '09:20', end: '16:10' },
      { start: '1200', end: '1300' }
    );
    // var url = window.location.href;
    var url = document.referrer;
    var a = url.split('?');
    var b = a[1].split('&');
    var theme = null;
    for (let i = 0; i < b.length; i++) {
      let arr = b[i].split('=');
      if (arr[0].replace(/(^\s*)|(\s*$)/g, '') == 'theme') {
        theme = arr[1];
      }
    }
    if (theme == 'newblack') {
      this.colorConfig = '#fff';
      this.djColor = '#272841';
      this.lineColor = '#e4e4f2';
    } else if (theme == 'newgrey') {
      this.colorConfig = '#181c21';
    } else {
      this.colorConfig = '#19191b';
    }
    this.compShareData();
  },
  mounted() {
    this.getSelect(this.name);
    if (this.isMainMoney) {
      this.initChart(
        undefined,
        this.newShareData.lgtmm,
        this.newShareData.hgtmm,
        this.newShareData.gtmm
      );
    } else {
      this.initChart(
        undefined,
        this.shareData.total_buy,
        this.shareData.h_buy,
        this.shareData.s_buy
      );
    } // 修改为默认显示所有数据
  },
  methods: {
    createNorthAxis_mm() {
      const res = getTimeList({ start: '09:30', end: '15:00' }, { start: '09:30', end: '15:00' });
      const index = 121;
      //剔除13：00对应的x轴坐标
      res.splice(index, 1);
      this.northAxis_mm = res;
    },

    onChange() {
      // 埋点
      let fsStat = this.name === 'northShare' ? 'bxfs' : 'nxfs';
      let status = this.checkedList.length > this.statCont.length ? 'select' : 'cancel';
      let diff = this.getArrDifference(this.checkedList, this.statCont)[0];
      if (diff === '北向资金') {
        window.TA.log({
          id: `webhsgt_${fsStat}_bxzj_${status}`,
        });
      } else if (diff === '南向资金') {
        window.TA.log({
          id: `webhsgt_${fsStat}_nxzj_${status}`,
        });
      } else if (diff === this.plainOptions[1]) {
        window.TA.log({
          id: `webhsgt_${fsStat}_hgt_${status}`,
        });
      } else if (diff === this.plainOptions[2]) {
        window.TA.log({
          id: `webhsgt_${fsStat}_sgt_${status}`,
        });
      }
      this.statCont = this.checkedList;
      this.compShareData();
    },
    getArrDifference(arr1, arr2) {
      /* 获取两个数组不相同的元素 */
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    getSelect(name) {
      event.subscribe('selcted' + name, data => {
        this.indexName = data;
        let indexStat = '';
        if (data === '上证指数') {
          this.surIndex = this.indexData['16_1A0001'];
          indexStat = 'szzs';
        } else if (data === '深证成指') {
          this.surIndex = this.indexData['32_399001'];
          indexStat = 'szcz';
        } else if (data === '上证50指数') {
          this.surIndex = this.indexData['16_1B0016'];
          indexStat = 'sz50';
        } else if (data === '创业板指') {
          this.surIndex = this.indexData['32_399006'];
          indexStat = 'cybz';
        } else if (data === '恒生指数') {
          this.surIndex = this.indexData['176_HSI'];
          indexStat = 'hszs';
        } else if (data === '恒生综合大型指数') {
          this.surIndex = this.indexData['176_HSLI'];
          indexStat = 'hsdx';
        } else if (data === '恒生综合中型指数') {
          this.surIndex = this.indexData['176_HSMI'];
          indexStat = 'hszx';
        } else if (data === '恒生综合小型指数') {
          this.surIndex = this.indexData['176_HSSI'];
          indexStat = 'hsxx';
        } else {
          this.surIndex = {};
        }
        if (name === 'northShare') {
          this.currentY = this.surIndex.dotsCount
            ? this.splitData(this.surIndex.data.split(';')).yData
            : undefined;
        } else {
          this.currentY = this.surIndex.dotsCount
            ? this.splitData1(this.surIndex.data.split(';')).yData
            : undefined;
        }
        this.compShareData();
        // 分时埋点
        if (name === 'northShare') {
          window.TA.log({
            id: `webhsgt_bxfs_djzs_${indexStat}`,
          });
        } else {
          window.TA.log({
            id: `webhsgt_nxfs_djzs_${indexStat}`,
          });
        }
      });
    },
    compShareData() {
      /*
       * 存储纵坐标数据
       */
      let y1, y2, y3;
      if (this.sharingTab === 1) {
        y1 = this.checkedList.includes(this.plainOptions[0]) ? this.shareData.total : undefined;
        y2 = this.checkedList.includes(this.plainOptions[1]) ? this.shareData.h : undefined;
        y3 = this.checkedList.includes(this.plainOptions[2]) ? this.shareData.s : undefined;
      } else {
        if (this.isMainMoney) {
          y1 = this.checkedList.includes(this.plainOptions[0])
            ? this.newShareData.lgtmm
            : undefined;
          y2 = this.checkedList.includes(this.plainOptions[1])
            ? this.newShareData.hgtmm
            : undefined;
          y3 = this.checkedList.includes(this.plainOptions[2])
            ? this.newShareData.sgtmm
            : undefined;
        } else {
          y1 = this.checkedList.includes(this.plainOptions[0])
            ? this.shareData.total_buy
            : undefined;
          y2 = this.checkedList.includes(this.plainOptions[1]) ? this.shareData.h_buy : undefined;
          y3 = this.checkedList.includes(this.plainOptions[2]) ? this.shareData.s_buy : undefined;
        }
      }
      let yData = this.currentY;
      // console.log("Y轴", yData)
      this.initChart(yData, y1, y2, y3);
    },
    splitData(data) {
      let xData = [];
      let yData = [];
      //去除13：00数据
      const index = 121;
      const copyData = [...data];
      copyData.splice(index,1);
      copyData.map(d => {
        xData.push(d.split(',')[0]);
        yData.push(d.split(',')[1]);
      });
      return {
        xData,
        yData,
      };
    },
    splitData1(data) {
      let xData = [];
      let yData = [];
      if (this.sharingTab === 1) {
        yData = new Array(30).fill('-'); // 为指数数据填充30个空数据
      } else {
        yData = new Array(10).fill('-');
      }
      data.map(d => {
        xData.push(d.split(',')[0]);
        yData.push(d.split(',')[1]);
      });
      for (let i = 0; i < 10; i++) {
        yData.push('-');
      }
      return {
        xData,
        yData,
      };
    },
    initChart(yData, y1, y2, y3) {
      let that = this;
      /*
       * @yData { Array | undefined } 叠加指数数据
       * @y1 { Array | undefined } 总资金流入数据
       * @y2 { Array | undefined } 沪股通数据
       * @y3 { Array | undefined } 深股通数据
       */
      let el = this.$refs.sharing;
      let chart = window.echarts.init(el);
      let xAxis;
      if (this.sharingTab === 0) {
        xAxis = this.name === 'northShare' ? this.northAxis_mm : this.southAxis_buy;
      } else {
        xAxis = this.name === 'northShare' ? this.northAxis : this.southAxis;
      }
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let toolCont = '';
            let time = params[0].axisValue;
            time = time.substr(0, 2) + ':' + time.substr(2, 2);
            let flag = 0;
            for (let i = 0; i < params.length; i++) {
              flag = params[i].value || params[i].value === 0 ? flag : flag + 1;
              let color = params[i].value > 0 ? '#e60012' : '#22ac38';
              if (params[i].value == 0) color = '#a7a7a7';
              let color1;
              this.surIndex.pre &&
                (color1 = params[i].value >= this.surIndex.pre ? '#e60012' : '#22ac38');
              if (params[i].seriesName.indexOf('指') === -1) {
                if (params[i].value || params[i].value === 0) {
                  if (that.isMainMoney) {
                    toolCont +=
                      params[i].value !== '-'
                        ? `<div>${params[i].seriesName}：<span style="color:${color}">${
                            params[i].value ? params[i].value.toFixed(2) : '0.00'
                          }亿</span></div>`
                        : '';
                  } else {
                    toolCont +=
                      params[i].value !== '-'
                        ? `<div>${params[i].seriesName}净${
                            that.sharingTab === 0 ? '买' : '流'
                          }入：<span style="color:${color}">${
                            params[i].value ? params[i].value.toFixed(2) : '0.00'
                          }亿</span></div>`
                        : '';
                  }
                }
              } else {
                if (params[i].value || params[i].value === 0) {
                  toolCont +=
                    params[i].value !== '-'
                      ? `<div>${params[i].seriesName}：<span style="color:${color1}">${params[i].value}</span></div>`
                      : '';
                }
              }
            }
            if (flag === params.length) {
              return '';
            }
            return `<div style="padding:12px 14px;background:#131315;border:1px solid #484848;border-radius:1px;opacity:0.8;">
                            <div><span></span>${time}</div>
                            ${toolCont} 
                        </div>`;
          },
        },
        legend: {
          show: false,
        },
        backgroundColor: this.colorConfig,
        grid: {
          left:
            (y1 && y1.length > 0) || (y2 && y2.length > 0) || (y3 && y3.length > 0) ? '10' : '15',
          right: '10',
          bottom: '10',
          top: '30',
          containLabel: true,
          borderColor: 'transparent',
          backgroundColor: '#131315',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: { show: false },
          axisLabel: {
            color: '#5b5b5b',
            fontFamily: 'SimSun',
            formatter: value => {
              let val =
                this.name === 'northShare'
                  ? ['0910', '0930', '1030', '1130', '1400', '1455']
                  : ['0900', '0930', '1200', '1400', '1605'];
              if (that.sharingTab === 0)
                val =
                  this.name === 'northShare'
                    ? ['0930', '1030', '1130', '1400', '1455']
                    : ['0920', '1200', '1400', '1605'];
              if (val.includes(value)) {
                value = value === '1455' ? '1500' : value;
                value = value === '1605' ? '1610' : value;
                return value.substr(0, 2) + ':' + value.substr(2, 2);
              }
            },
            interval: 0,
          },
          data: xAxis,
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: function (value) {
                if (value > 0) {
                  return '#c63031';
                } else if (value < 0) {
                  return '#22ac38';
                } else {
                  return '#717171';
                }
              },
              formatter: function (value) {
                if (value > 0) {
                  return value.toFixed(2);
                } else if (value < 0) {
                  return value.toFixed(2);
                } else {
                  return value;
                }
              },
              fontFamily: 'SimSun',
            },
            axisTick: { show: false },
            splitLine: {
              lineStyle: {
                color: this.lineColor,
                width: 1,
              },
            },
            name:
              (y1 && y1.length > 0) || (y2 && y2.length > 0) || (y3 && y3.length > 0)
                ? '(亿)         '
                : '', // 存在净流入才显示
            nameTextStyle: {
              color: '#5b5b5b',
            },
            minInterval: 2,
          },
          {
            type: 'value',
            axisLabel: {
              color: '#5b5b5b',
              formatter: function (value) {
                return value + '';
              },
            },
            axisTick: { show: false },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#1f2125',
                width: 1,
              },
            },
            min: function (value) {
              return parseInt(value.min - 20);
            },
          },
        ],
        series: [
          {
            name: this.name === 'northShare' ? '陆股通成分股资金流向' : '南向资金',
            type: 'line',
            data: y1 || [] /* this.shareData.total */,
            lineStyle: {
              color: '#d9ab44',
              width: 2,
            },
            symbol: 'none',
          },
          {
            name: this.name === 'northShare' ? '沪' : '港股通(沪)',
            type: 'line',
            data: y2 || [] /* this.shareData.h */,
            lineStyle: {
              color: '#e63030',
              width: 1,
            },
            symbol: 'none',
          },
          {
            name: this.name === 'northShare' ? '深' : '港股通(深)',
            type: 'line',
            data: y3 || [] /* this.shareData.s */,
            lineStyle: {
              color: '#3d76b8',
              width: 1,
            },
            symbol: 'none',
          },
          {
            name: this.indexName,
            type: 'line',
            data: yData || [],
            yAxisIndex: 1,
            symbol: 'none',
            lineStyle: {
              color: '#cececf',
              width: 1,
            },
            itemStyle: {
              normal: {
                lineStyle: {
                  type: 'solid',
                  color: this.djColor,
                  width: 1,
                },
              },
            },
          },
        ],
      });
    },
  },
  watch: {
    shareData() {
      this.compShareData();
    },
    newShareData() {
      this.compShareData();
    },
    indexData() {
      let data = this.indexName;
      if (data === '上证指数') {
        this.surIndex = this.indexData['16_1A0001'];
      } else if (data === '深证成指') {
        this.surIndex = this.indexData['32_399001'];
      } else if (data === '上证50指数') {
        this.surIndex = this.indexData['16_1B0016'];
      } else if (data === '创业板指') {
        this.surIndex = this.indexData['32_399006'];
      } else if (data === '恒生指数') {
        this.surIndex = this.indexData['176_HSI'];
      } else if (data === '恒生综合大型指数') {
        this.surIndex = this.indexData['176_HSLI'];
      } else if (data === '恒生综合中型指数') {
        this.surIndex = this.indexData['176_HSMI'];
      } else if (data === '恒生综合小型指数') {
        this.surIndex = this.indexData['176_HSSI'];
      } else {
        this.surIndex = {};
      }
      if (this.name === 'northShare') {
        this.currentY = this.surIndex.dotsCount
          ? this.splitData(this.surIndex.data.split(';')).yData
          : undefined;
      } else {
        this.currentY = this.surIndex.dotsCount
          ? this.splitData1(this.surIndex.data.split(';')).yData
          : undefined;
      }
      this.compShareData();
    },
    sharingTab() {
      if (this.name === 'northShare') {
        this.currentY = this.surIndex.dotsCount
          ? this.splitData(this.surIndex.data.split(';')).yData
          : undefined;
      } else {
        this.currentY = this.surIndex.dotsCount
          ? this.splitData1(this.surIndex.data.split(';')).yData
          : undefined;
      }
      this.compShareData();
    },
  },
};
</script>

<style lang="less">
.fund-sharing-wrap {
  position:relative;
  .fund-sharing-chart {
    height: 186px;
    > div:last-child {
      background: none !important;
    }
  }
  /* checkbox 样式 */
  .legend-checkbox {
    height: 26px;
    line-height: 26px;
    width: 100%;
    text-align: center;
    .ant-checkbox {
      width: 13px;
      height: 13px;
      .ant-checkbox-inner {
        width: 13px;
        height: 13px;
        background: #393939;
        border-color: #484848;
      }
      &.ant-checkbox-checked {
        .ant-checkbox-input {
          background: #393939;
        }
        .ant-checkbox-inner {
          background-color: #393939;
          border-color: #484848;
          &::after {
            border: 2px solid #efefef;
            width: 5px;
            height: 8px;
            border-left: 0;
            border-top: 0;
            left: 3px;
          }
        }
      }
    }
    .ant-checkbox-wrapper {
      font-size: 12px;
      span {
        color: #e63030;
      }
      &:first-child {
        span {
          color: #d9ab44;
        }
      }
      &:last-child {
        span {
          color: #3d76b8;
        }
      }
    }
  }
  .tip {
    position:absolute;
    top:0px;
    left:100px;
    color: #c5c3c6;
    font-size: 14px;
  }
}
.ant-radio-group {
  font-family: SimSun;
}
.ant-radio-wrapper {
  font-family: SimSun;
}
.ant-checkbox-wrapper {
  font-family: SimSun;
}

.newblack {
  .fund-sharing-wrap {
    .legend-checkbox {
      .ant-checkbox {
        .ant-checkbox-inner {
          border-color: #272841;
          background: #fff;
        }
        &.ant-checkbox-checked {
          .ant-checkbox-input {
            background: #fff;
          }
          .ant-checkbox-inner {
            background-color: #fff;
            border-color: #272841;
            &::after {
              border: 2px solid #272841;
              width: 5px;
              height: 8px;
              border-left: 0;
              border-top: 0;
              left: 3px;
            }
          }
        }
      }
    }
  }
}
.newgrey {
  .fund-sharing-wrap {
    .legend-checkbox {
      .ant-checkbox {
        .ant-checkbox-inner {
          border-color: #393941;
          background: #393941;
        }
        &.ant-checkbox-checked {
          .ant-checkbox-input {
            background: #393941;
          }
          .ant-checkbox-inner {
            background-color: #393941;
            border-color: #393941;
            &::after {
              border: 2px solid #fff;
              width: 5px;
              height: 8px;
              border-left: 0;
              border-top: 0;
              left: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
